import { render, staticRenderFns } from "./TxRowMobile.vue?vue&type=template&id=02305565"
import script from "./TxRowMobile.vue?vue&type=script&lang=js"
export * from "./TxRowMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports